import {useEffect, useState} from 'react'
import {useOccupancy} from '../../../../hooks/useOccupancy'
import {ViewOccupancyLayout} from '../../../ocupability/components/ViewOccupancyLayout'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {getModuleByIdService} from '../../services'

type SelectionRecord = {
  company?: string
  client?: string
  site?: string
  camp?: string
  mod?: string
  pis?: string
  hbt?: string
}

export const OccupancyLayout = () => {
  const [selectedOption, setSelectedOption] = useState<SelectionRecord>({})
  const [selectedOptionName, setSelectedOptionName] = useState<SelectionRecord>({})
  const {layoutData, getLayoutList, setLayoutData, TipoData, setTipoData, isLoading} =
    useOccupancy()
  const {currentTabItem} = useHoteleria()
  const {idToEdit} = currentTabItem

  const getDataLoad = async () => {
    const {
      data: {data},
    } = await getModuleByIdService(idToEdit)
    const {CompaniaId, ClienteId, SiteId, CampamentoId, Id} = data

    setSelectedOption((prevSelectedOption) => ({
      ...prevSelectedOption,
      company: CompaniaId,
      client: ClienteId,
      site: SiteId,
      camp: CampamentoId,
      mod: Id as string,
    }))

    setSelectedOptionName((prevSelectedOptionName) => ({
      ...prevSelectedOptionName,
      mod: 'Pisos',
    }))
  }

  const loadFloorsLayout = () => {
    let TipoDataIn = 'PIS'
    setTipoData(TipoDataIn)
    setLayoutData([])
    setSelectedOption({...selectedOption, mod: selectedOption.mod, pis: '', hbt: ''})
    setSelectedOptionName({...selectedOptionName, mod: selectedOptionName.mod, pis: '', hbt: ''})
    getLayoutList({
      TipoData: TipoDataIn,
      CompaniaId: selectedOption.company,
      ClienteId: selectedOption.client,
      SiteId: selectedOption.site,
      CampamentoId: selectedOption.camp,
      ModuloId: selectedOption.mod,
    })
  }

  const loadHabiationsLayout = (pisoId: any, name: string) => {
    let TipoDataIn = 'HAB'
    setTipoData(TipoDataIn)
    setLayoutData([])
    setSelectedOption({...selectedOption, pis: pisoId, hbt: ''})
    setSelectedOptionName({...selectedOptionName, pis: name, hbt: ''})
    getLayoutList({
      TipoData: TipoDataIn,
      CompaniaId: selectedOption.company,
      ClienteId: selectedOption.client,
      SiteId: selectedOption.site,
      CampamentoId: selectedOption.camp,
      ModuloId: selectedOption.mod,
      PisoId: pisoId,
    })
  }
  const loadBedsLayout = (habitacionId: any, name: string) => {
    let TipoDataIn = 'CAM'
    setTipoData(TipoDataIn)
    setLayoutData([])
    setSelectedOption({...selectedOption, hbt: habitacionId})
    setSelectedOptionName({...selectedOptionName, hbt: name})
    getLayoutList({
      TipoData: TipoDataIn,
      CompaniaId: selectedOption.company,
      ClienteId: selectedOption.client,
      SiteId: selectedOption.site,
      CampamentoId: selectedOption.camp,
      ModuloId: selectedOption.mod,
      PisoId: selectedOption.pis,
      HabitacionId: habitacionId,
    })
  }

  useEffect(() => {
    getDataLoad()
  }, [])

  useEffect(() => {
    if (selectedOption['mod'] && selectedOption['mod'] !== '0') {
      loadFloorsLayout()
    }
  }, [selectedOption.mod])
  return (
    <div className='sdx_form card p-4'>
      <ViewOccupancyLayout
        isLoadingLayout={isLoading}
        data={layoutData}
        selectedOptionName={selectedOptionName}
        selectedOption={selectedOption}
        tipoData={TipoData}
        loadFloorsLayout={loadFloorsLayout}
        loadHabiationsLayout={loadHabiationsLayout}
        loadBedsLayout={loadBedsLayout}
      />
    </div>
  )
}
